import { HashRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import QuotePage from './pages/QuotePage';
import BlogListPage from './pages/BlogListPage';
import BlogPostPage from './pages/BlogPostPage';
import ContactPage from './pages/ContactPage';
import './index.css';

function LangRoutes() {
  // handle i18n language in path
  const { lng } = useParams();
  const { i18n } = useTranslation();
  const valid = ['sr', 'en'];
  useEffect(() => {
    if (i18n.language !== lng) i18n.changeLanguage(lng);
  }, [lng, i18n]);
  if (!valid.includes(lng)) return <Navigate to="/sr" replace />;
  return (
    <>
      <Header />
      <Routes>
        <Route index element={<HomePage />} />
        <Route path="quote" element={<QuotePage />} />
        <Route path="blog" element={<BlogListPage />} />
        <Route path="blog/:slug" element={<BlogPostPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="*" element={<Navigate to={`/${lng}`} replace />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
  <HashRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/sr" replace />} />
          <Route path="/:lng/*" element={<LangRoutes />} />
        </Routes>
  </HashRouter>
    </HelmetProvider>
  );
}

export default App;
